<template>
  <ais-pagination @page-change="pageChange">
    <template
      v-slot="{
        currentRefinement,
        nbPages,
        pages,
        isFirstPage,
        isLastPage,
        refine,
        createURL
      }"
    >
      <nav v-if="pages.length > 1" class="flex items-center gap-x-2 p-2 mx-auto border bg-grey-lightest border-grey-border w-fit mb-10">
        <a :href="createURL(isFirstPage ? nbPages : currentRefinement - 1)" @click.prevent="refine(isFirstPage ? nbPages : currentRefinement - 1)">
          <img data-src="/assets/images/icons/caret/bordered-left.svg" class="cursor-pointer lazyload hover-shadow" width="31" height="32" alt="Previous Page">
        </a>

        <a
          v-for="page in pages" :key="page"
          :href="createURL(page)"
          @click.prevent="refine(page)"
          :class="`
          border border-grey-border w-[18px] h-[18px] text-[10px] grid place-items-center hover:text-white hover:bg-${theme} transition-all duration-300
          ${currentRefinement === page ? `bg-${theme} text-white` : ''}`"
        >
          {{ page + 1 }}
        </a>

        <a :href="createURL(isLastPage ? 0 : currentRefinement + 1)" @click.prevent="refine(isLastPage ? 0 : currentRefinement + 1)">
          <img data-src="/assets/images/icons/caret/bordered-right.svg" class="order-last cursor-pointer lazyload hover-shadow" width="31" height="32" alt="Next Page">
        </a>
      </nav>

      <div v-else></div>
    </template>
  </ais-pagination>
</template>

<script>
  import { AisPagination } from 'vue-instantsearch';

  export default {
    name: "Pagination",
    props: {
      scrollToSelector: {
        type: String,
        default: null,
      },
      theme: {
        type: String,
        default: 'purple',
      },
    },
    methods: {
      pageChange() {
        document.querySelector(this.scrollToSelector ?? '.ais-SearchBox').scrollIntoView({
          behavior: 'smooth'
        });
      }
    },
    components: {
      AisPagination
    }
  }
</script>